import { useTranslation } from "react-i18next"
import Section from "components/layout/section"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import DeleteAccountForm from "@/features/account/deleteAccountForm"
import Callout from "@/components/callout/callout"

const DeleteAccountPage = () => {
    const { t } = useTranslation()

    return (
        <>
            <PageTitle title={t("titleDeleteAccount")} />
            <Section>
                <Callout type="error">{t("deleteAccountWarning")}</Callout>
            </Section>
            <Section>
                <DeleteAccountForm />
            </Section>
            <RightSidebar />
        </>
    )
}

export default DeleteAccountPage
